import React, {Component} from 'react';
import './userstore.css';


class UserStore extends Component {
    
    render() {
        return(
            <div>
            <div className="App-header">
            </div>
            <div>
            This is the users Store
            </div>
            </div>
        )
    }
}

export default UserStore;